import { AlertCircle } from "lucide-react";
import { cn } from "@/shared/utils/cn";

interface EmptyStateProps {
  icon?: React.ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({
  icon: Icon = AlertCircle,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn("text-center py-12", className)} data-testid="empty-state">
      <Icon className="mx-auto h-12 w-12 text-muted-foreground mb-4" data-testid="empty-state-icon" />
      <h3 className="text-lg font-semibold text-foreground mb-2" data-testid="empty-state-title">
        {title}
      </h3>
      {description && (
        <p className="text-muted-foreground mb-6 max-w-sm mx-auto" data-testid="empty-state-description">
          {description}
        </p>
      )}
      {action && <div data-testid="empty-state-action">{action}</div>}
    </div>
  );
}
